import { animate, animateChild, group, query, style, transition, trigger, useAnimation } from '@angular/animations';
import { bounce, fadeIn, fadeInDown, zoomIn, zoomOut, slideInRight, shake } from 'ng-animate';

export const classicBounce = trigger('bounce', [transition('* => *', useAnimation(bounce))]);
export const bounceEnter = trigger('bounceEnter', [transition('void => *', useAnimation(bounce))]);

export const classicFadeIn = trigger('fadeIn', [transition('* => *', useAnimation(fadeIn))]);
export const fadeInEnter = trigger('fadeInEnter', [transition('void => *', useAnimation(fadeIn))]);

export const classicFadeInDown = trigger('fadeInDown', [transition('* => *', useAnimation(fadeInDown))]);
export const fadeInDownEnter = trigger('fadeInDownEnter', [transition('void => *', useAnimation(fadeInDown))]);

export const classicSlideInRight = trigger('slideInRight', [transition('* => *', useAnimation(slideInRight))]);
export const slideInRightEnter = trigger('slideInRightEnter', [transition('void => *', useAnimation(slideInRight))]);
export const slideInRightLeave = trigger('slideInRightLeave', [transition('* => void', useAnimation(slideInRight))]);


export const dashboardTileDialog = trigger('animation',
[
    transition('void => *', useAnimation(zoomIn, {
        params: { timing: 0.5, delay: 0 }
    }))
]);

export const memberSlideInAnimation =
    trigger('routeAnimations', [
        transition('* => dashboard', [
            style({ position: 'relative' }),
            query(':enter, :leave', [
                style({
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    width: '100%',
                    height: '*'
                })
            ], { optional: true }),
            query(':enter', [
                style({ right: '-100%' })
            ], { optional: true }),
            query(':leave', animateChild(), { optional: true }),
            group([
                query(':leave', [
                    animate('250ms ease-out', style({ right: '100%' }))
                ], { optional: true }),
                query(':enter', [
                    animate('250ms ease-out', style({ right: '0%' }))
                ], { optional: true })
            ])
        ]),

        transition('* <=> *', [
            style({ position: 'relative' }),
            query(':enter, :leave', [
                style({
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '*'
                })
            ], { optional: true }),
            query(':enter', [
                style({ left: '-100%' })
            ], { optional: true }),
            query(':leave', animateChild(), { optional: true }),
            group([
                query(':leave', [
                    animate('250ms ease-out', style({ left: '100%' }))
                ], { optional: true }),
                query(':enter', [
                    animate('250ms ease-out', style({ left: '0%' }))
                ], { optional: true })
            ]),
            // query(':enter', animateChild(), {optional: true}),
        ])
    ]);


// export const memberSlideInAnimation =
//   trigger('routeAnimations', [
//     transition('* <=> *', [
//       style({ position: 'relative' }),
//       query(':enter, :leave', [
//         style({
//           position: 'absolute',
//           top: 0,
//           left: 0,
//           width: '100%',
//           height: '*'
//         })
//       ], {optional: true}),
//       query(':enter', [
//         style({ left: '-100%'})
//       ], {optional: true}),
//       query(':leave', animateChild(), {optional: true}),
//       group([
//         query(':leave', [
//           animate('500ms ease-out', style({ left: '100%'}))
//         ], {optional: true}),
//         query(':enter', [
//           animate('500ms ease-out', style({ left: '0%'}))
//         ], {optional: true})
//       ]),
//       // query(':enter', animateChild(), {optional: true}),
//     ])
//   ]);
